import React from 'react';
import {Box, Container, Typography} from '@mui/material';
import Grid from "@mui/material/Grid2";
import {Trans} from "react-i18next";

const Contact = () => {
    return (
        <Container maxWidth={'md'} sx={{pt: 3}}>
            <Grid container spacing={3}>
                <Grid size={{xs: 12, md: 6}}>
                    <Typography variant="h6" sx={{py: 2}}>
                        <Trans i18nKey={'contactPage.contactLabel'}/>
                    </Typography>
                    <Box sx={{marginBottom: 2}}>
                        <Typography variant="body1">
                            <strong><Trans i18nKey={"legal.addressLabel"}/>:</strong> <Trans i18nKey={"legal.address"}/>
                        </Typography>
                        <Typography variant="body1">
                            <strong><Trans i18nKey={"auth.email"}/>:</strong> <Trans i18nKey={"legal.email"}/>
                        </Typography>
                        <Typography variant="body1">
                            <strong><Trans i18nKey={"addressForm.telNr"}/>:</strong> <Trans i18nKey={"legal.telNr"}/>
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Typography variant="h6" sx={{py: 2}}>
                        <Trans i18nKey={"contactPage.mapLabel"}/>
                    </Typography>
                    <iframe
                        title="map"
                        width="100%"
                        height="350"
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBaR3uobzYMXsUxPbv44ik0gR4j59rZh3Y&q=Harghita+Business+Center,Odorheiu+Secuiesc">
                    </iframe>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Contact;
